export default __webpack_public_path__ + "static/media/course.fdd455fb.svg";